<template>
  <el-dialog
    title="其他链接"
    center
    :visible.sync="urlInputDialog"
    v-if="urlInputDialog"
    append-to-body
    width="600px"
    :before-close="beforeclose"
  >
    <el-form :model="formData" size="medium" ref="searchForm" :rules="rules">
      <el-form-item
        style="display: flex;align-items: center;"
        label="链接路径"
        prop="url"
      >
        <el-input
          v-model="formData.url"
          placeholder="请输入链接路径"
          clearable
        ></el-input>
      </el-form-item>
    </el-form>
    <el-row type="flex" justify="center" style="margin-top: 30px">
      <el-button @click="beforeclose">取消</el-button>
      <el-button type="primary" @click="saveData">保存</el-button>
    </el-row>
  </el-dialog>
</template>

<script>
export default {
  name: "urlInput",
  props: ["urlInputDialog"],
  components: {},
  data() {
    return {
      formData: {
        url: ""
      },
      rules: {
        url: [{ required: true, message: "请输入链接路径", trigger: "blue" }]
      }
    };
  },
  created() {},
  watch: {
    urlInputDialog: {
      handler(newVal, oldVal) {
        if (newVal) {
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {},
  methods: {
    beforeclose() {
      this.formData.url = "";
      this.$emit("closeurlInputDialog", false);
    },
    saveData() {
      var reg = /^http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?$/;
      let urllink = this.formData.url;
      if (!reg.test(urllink)) {
        this.$message.warning("请输入正确的链接");
        return;
      } else {
        this.$emit("inputValueSelect", this.formData.url);
      }
    }
  }
};
</script>

<style scoped lang="less">
/deep/ .el-form-item__content {
  flex: 1;
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/components/FillInOtherLinkDialog.vue